import React, { useState } from 'react';
import styles from './PublicMessage.module.css';

function PublicMessage({ onClose }) {
  const [currentAd, setCurrentAd] = useState(0);

  const advertisements = [
    {
      id: 1,
      type: 'discount',
      title: '🎊 限时特惠',
      subtitle: '年度最大力度促销',
      description: '全场功能8折起，VIP会员买一送一',
      buttonText: '立即查看',
      deadline: '2026-12-31',
      bgColor: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)',
      textColor: '#fff'
    },
    {
      id: 2,
      type: 'new',
      title: '🚀 新功能上线',
      subtitle: '智能助手正式发布',
      description: 'AI 帮你更高效完成任务，立即体验',
      buttonText: '免费试用',
      deadline: '2026-11-30',
      bgColor: 'linear-gradient(135deg, #4ECDC4 0%, #44A08D 100%)',
      textColor: '#fff'
    }
  ];

  const current = advertisements[currentAd];

  return (
    <div className={styles.publicMessage}>
      <div
        className={styles.adContainer}
        style={{
          background: current.bgColor,
          color: current.textColor
        }}
      >
        <button className={styles.closeButton} onClick={onClose}>×</button>

        <div className={styles.adContent}>
          <div className={styles.adBadge}>
            {current.type === 'discount' ? '热卖' : '新品'}
          </div>

          <div className={styles.adHeader}>
            <h3 className={styles.adTitle}>{current.title}</h3>
            <p className={styles.adSubtitle}>{current.subtitle}</p>
          </div>

          <p className={styles.adDescription}>{current.description}</p>

          <div className={styles.adFooter}>
            <button className={styles.actionButton}>{current.buttonText}</button>
            <div className={styles.deadline}>截止: {current.deadline}</div>
          </div>
        </div>

        <div className={styles.carouselControls}>
          {advertisements.map((_, index) => (
            <button
              key={index}
              className={`${styles.dot} ${index === currentAd ? styles.active : ''}`}
              onClick={() => setCurrentAd(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default PublicMessage;